import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector} from 'react-redux';
import UserCard from './UserCard';
import { RootState } from '../../../../store/types';
import { i18n } from '../../../../translate/i18n';


const UserCardList: React.FC = () => {
  const users = useSelector((state: RootState) => state.scheduledServices.users);
  return (
    <Box sx={styles.listContainer}>
      <Typography variant='h6' sx={styles.employeesTitle}>
        {i18n.t('scheduledServicesUsersList.title') as string}
      </Typography>
      <Box>
        { users.map((user) => <UserCard key={user._id} user={user} />) }
      </Box>
    </Box>  
  )
};

export default UserCardList;

const styles = {
  employeesTitle: {
    paddingBottom: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    position: 'sticky',
    zIndex: 2001,
    top: 0,
    backgroundColor: '#FFF',
    borderBottom: '1px solid lightGrey',
    width: '23rem'
  },
  listContainer: {
    width: '30%',
    position: 'sticky',
    left: 0,
    zIndex: 1000,
    backgroundColor: '#fff',
    maxWidth: '23rem',
    minWidth: '20rem'
  },
}
